import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

//Component - Layout subnavigation routes (child):
import SubnavigationRoutes from 'router/routes/subnavigation';

import { useLayoutMenu } from '../hooks/useLayoutMenu';
import { contentStyle } from '../styles/layoutStyles';

const LayoutContent = () => {
  const { open } = useLayoutMenu() || {};
  const theme = useTheme();

  return (
    <Grid
      container
      sx={{
        ...contentStyle({ theme, open }),
        py: 3,
      }}
    >
      <Grid size={{ xs: 12 }}>
        <SubnavigationRoutes />
      </Grid>
    </Grid>
  );
};

export default LayoutContent;
